export const JobRequestStatuses = {
    Submitted: 1,
    Approved: 2,
    Rejected: 3,
    JobCreated: 4,
};